module.exports = __webpack_public_path__ + "static/media/1.394e8606.jpg";